class $d5ab0e61de8d05a3$export$4fae95256245c8c0 {
    on(events, callback) {
        const register = (event)=>{
            if (!this.events[event]) this.events[event] = [];
            this.events[event].push(callback);
        };
        if (Array.isArray(events)) events.forEach(register);
        else register(events);
    }
    off(event, callback) {
        if (this.events[event]) this.events[event] = this.events[event].filter((cb)=>cb !== callback);
    }
    emit(event, data) {
        if (this.events[event]) this.events[event].forEach((callback)=>callback(data));
    }
    clear() {
        this.events = {};
    }
    constructor(){
        this.events = {};
    }
}


const $2f574e067eb2596f$export$ada873a34909da65 = {
    LOOP_START: 'loop:start',
    LOOP_STOP: 'loop:stop',
    LOOP_CLEAR: 'loop:clear',
    NOTE_PRESSED: 'note:pressed',
    NOTE_RELEASED: 'note:released',
    PLAYBACK_NOTE_PRESSED: 'playback:notePressed',
    PLAYBACK_NOTE_RELEASED: 'playback:noteReleased',
    STATE_CHANGED: 'state:changed'
};
class $2f574e067eb2596f$export$9990ea4e6d0d6bd5 {
    constructor(eventBus){
        this.eventBus = eventBus;
        this.isRecording = false;
        this.isPlaying = false;
        this.currentLoop = [];
        this.recordingStartTime = 0;
        this.playbackTimeouts = [];
        this.setupEventHandlers();
    }
    setupEventHandlers() {
        this.eventBus.on($2f574e067eb2596f$export$ada873a34909da65.LOOP_START, ()=>{
            this.startLoop();
        });
        this.eventBus.on($2f574e067eb2596f$export$ada873a34909da65.LOOP_STOP, ()=>{
            this.stopLoop();
        });
        this.eventBus.on($2f574e067eb2596f$export$ada873a34909da65.LOOP_CLEAR, ()=>{
            this.clearLoop();
        });
        this.eventBus.on($2f574e067eb2596f$export$ada873a34909da65.NOTE_PRESSED, (data)=>{
            if (data) this.recordNoteEvent('start', data.note, data.frequency);
        });
        this.eventBus.on($2f574e067eb2596f$export$ada873a34909da65.NOTE_RELEASED, (data)=>{
            if (data) this.recordNoteEvent('stop', data.note, data.frequency);
        });
    }
    recordNoteEvent(type, note, frequency) {
        if (!this.isRecording) return;
        const timestamp = performance.now() - this.recordingStartTime;
        this.currentLoop.push({
            type: type,
            note: note,
            frequency: frequency,
            timestamp: timestamp
        });
    }
    startLoop() {
        if (this.isRecording || this.isPlaying) return;
        this.isRecording = true;
        this.currentLoop = [];
        this.recordingStartTime = performance.now();
        this.emitStateChange();
    }
    stopLoop() {
        if (!this.isRecording) return;
        this.isRecording = false;
        if (this.currentLoop.length > 0) this.playLoop();
        this.emitStateChange();
    }
    clearLoop() {
        this.stopPlayback();
        this.currentLoop = [];
        this.emitStateChange();
    }
    playLoop() {
        if (this.currentLoop.length === 0) return;
        this.isPlaying = true;
        this.emitStateChange();
        const duration = Math.max(...this.currentLoop.map((e)=>e.timestamp));
        const scheduleEvents = ()=>{
            this.playbackTimeouts = [];
            this.currentLoop.forEach((event)=>{
                const timeoutId = setTimeout(()=>{
                    if (!this.isPlaying) return;
                    if (event.type === 'start') this.eventBus.emit($2f574e067eb2596f$export$ada873a34909da65.PLAYBACK_NOTE_PRESSED, {
                        note: event.note,
                        frequency: event.frequency
                    });
                    else this.eventBus.emit($2f574e067eb2596f$export$ada873a34909da65.PLAYBACK_NOTE_RELEASED, {
                        note: event.note,
                        frequency: event.frequency
                    });
                }, event.timestamp);
                this.playbackTimeouts.push(timeoutId);
            });
            const endTimeoutId = setTimeout(()=>{
                if (this.isPlaying) scheduleEvents();
            }, duration + 100);
            this.playbackTimeouts.push(endTimeoutId);
        };
        scheduleEvents();
    }
    stopPlayback() {
        if (!this.isPlaying) return;
        this.playbackTimeouts.forEach(clearTimeout);
        this.playbackTimeouts = [];
        this.isPlaying = false;
        this.emitStateChange();
    }
    getState() {
        return {
            isRecording: this.isRecording,
            isPlaying: this.isPlaying,
            hasLoop: this.currentLoop.length > 0
        };
    }
    emitStateChange() {
        this.eventBus.emit($2f574e067eb2596f$export$ada873a34909da65.STATE_CHANGED, this.getState());
    }
}



class $566e2212a25b5c97$export$a100a513ac3d7fb0 {
    constructor(eventBus){
        this.eventBus = eventBus;
        this.keys = new Map();
        this.setupEventHandlers();
    }
    setupEventHandlers() {
        this.eventBus.on((0, $2f574e067eb2596f$export$ada873a34909da65).PLAYBACK_NOTE_PRESSED, (data)=>{
            if (data) this.playNoteByName(data.note);
        });
        this.eventBus.on((0, $2f574e067eb2596f$export$ada873a34909da65).PLAYBACK_NOTE_RELEASED, (data)=>{
            if (data) this.stopNoteByName(data.note);
        });
    }
    register(keyElement) {
        this.keys.set(keyElement.config.name, keyElement);
    }
    playNoteByName(noteName) {
        const keyElement = this.keys.get(noteName);
        if (keyElement) keyElement.playNote();
    }
    stopNoteByName(noteName) {
        const keyElement = this.keys.get(noteName);
        if (keyElement) keyElement.stopNote();
    }
}


function $041a823542846931$export$a1d0d20ee9546562() {
    // expect msMaxTouchPoints sometimes to be in the document
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}


class $5be042668c706f09$export$4c619579822a0af5 {
    #tag;
    #element;
    #attributes;
    #listeners;
    #children;
    constructor(tag, attributes = [], listeners = [], children = []){
        this.#children = [];
        this.#tag = tag;
        this.#attributes = new Map(attributes.map((attr)=>[
                attr.name,
                attr.value
            ]));
        this.#listeners = new Map(listeners);
        this.#children = Array.isArray(children) ? children : [
            children
        ];
    }
    get element() {
        return this.#element;
    }
    setChildren(children) {
        this.#children = Array.isArray(children) ? children : [
            children
        ];
        this.render();
        return this;
    }
    setAttributes() {
        this.#attributes.forEach((value, name)=>{
            this.#element?.setAttribute(name, value);
        });
    }
    id(id) {
        return this.attribute('id', id);
    }
    class(className) {
        return this.attribute('class', className);
    }
    attribute(name, value) {
        this.#attributes.set(name, value);
        this.#element?.setAttribute(name, value);
        return this;
    }
    getAttribute(name) {
        return this.#attributes.get(name);
    }
    removeAttribute(name) {
        this.#attributes.delete(name);
        this.#element?.removeAttribute(name);
        return this;
    }
    setListeners() {
        this.#listeners.forEach((fns, event)=>{
            fns.forEach((fn)=>{
                this.#element?.addEventListener(event, fn);
            });
        });
    }
    removeListeners() {
        if (!this.#element) return;
        this.#listeners.forEach((fns, event)=>{
            fns.forEach((fn)=>{
                this.#element?.removeEventListener(event, fn);
            });
        });
        this.#listeners.clear();
    }
    listen(event, fn) {
        const eventListeners = this.#listeners.get(event) ?? [];
        if (!eventListeners.includes(fn)) {
            eventListeners.push(fn);
            this.#listeners.set(event, eventListeners);
            this.#element?.addEventListener(event, fn);
        }
        return this;
    }
    unlisten(event, fn) {
        const eventListeners = this.#listeners.get(event);
        if (!eventListeners) return this;
        const updatedListeners = eventListeners.filter((f)=>f !== fn);
        if (updatedListeners.length > 0) this.#listeners.set(event, updatedListeners);
        else this.#listeners.delete(event);
        this.#element?.removeEventListener(event, fn);
        return this;
    }
    trigger(event) {
        this.#element?.dispatchEvent(new Event(event));
    }
    remove() {
        this.removeListeners();
        this.#element?.remove();
    }
    renderChildren() {
        this.#children.forEach((child)=>{
            if (child instanceof $5be042668c706f09$export$4c619579822a0af5) {
                this.#element?.appendChild(child.render());
                return;
            }
            if (typeof child === 'string') {
                this.#element?.appendChild(document.createTextNode(child));
                return;
            }
            throw new Error(`Invalid child: ${child} of type ${typeof child} at ${this.#tag}`);
        });
    }
    render() {
        if (!this.#element) {
            this.#element = document.createElement(this.#tag);
            this.#element.__uiElement = this;
        }
        this.setAttributes();
        this.setListeners();
        while(this.#element.firstChild)this.#element.removeChild(this.#element.firstChild);
        this.renderChildren();
        return this.#element;
    }
}
const $5be042668c706f09$var$tags = 'button,div,span,select,option'.split(',');
const $5be042668c706f09$var$createFactory = (tag)=>(arg)=>{
        if (!arg) return new $5be042668c706f09$export$4c619579822a0af5(tag);
        if (typeof arg === 'string') return new $5be042668c706f09$export$4c619579822a0af5(tag, [], [], arg);
        if (Array.isArray(arg)) return new $5be042668c706f09$export$4c619579822a0af5(tag, [], [], arg);
        if (typeof arg === 'object' && arg !== null) return new $5be042668c706f09$export$4c619579822a0af5(tag, arg.attributes, arg.listeners, arg.children);
        throw new Error(`Invalid argument: ${arg} of type ${typeof arg} for ${tag}`);
    };
const $5be042668c706f09$var$factories = Object.fromEntries($5be042668c706f09$var$tags.map((tag)=>[
        tag,
        $5be042668c706f09$var$createFactory(tag)
    ]));
const { button: $5be042668c706f09$export$2ba01fb71ed41cb6, div: $5be042668c706f09$export$159d9494db57879b, span: $5be042668c706f09$export$afc1bfabebaf28a2, select: $5be042668c706f09$export$2e6c959c16ff56b8, option: $5be042668c706f09$export$a75d1723e6bda2ec } = $5be042668c706f09$var$factories;
var $5be042668c706f09$export$2e2bcd8739ae039 = $5be042668c706f09$var$factories;


const $09eabb53e0d46f41$export$699930e54fabb97d = {
    SINE: 'sine',
    SQUARE: 'square',
    SAWTOOTH: 'sawtooth',
    TRIANGLE: 'triangle'
};
const $09eabb53e0d46f41$export$cafdd0d42ceca25c = [
    {
        value: $09eabb53e0d46f41$export$699930e54fabb97d.SINE,
        label: 'Sine Wave'
    },
    {
        value: $09eabb53e0d46f41$export$699930e54fabb97d.SQUARE,
        label: 'Square Wave'
    },
    {
        value: $09eabb53e0d46f41$export$699930e54fabb97d.SAWTOOTH,
        label: 'Sawtooth Wave'
    },
    {
        value: $09eabb53e0d46f41$export$699930e54fabb97d.TRIANGLE,
        label: 'Triangle Wave'
    }
];


class $e0ea8097d55977c9$export$85990f0f98a390bb {
    static{
        this.context = new AudioContext();
    }
    static{
        this.audios = new Map();
    }
    static{
        this.currentWaveType = (0, $09eabb53e0d46f41$export$699930e54fabb97d).SINE;
    }
    constructor(frequency){
        this.frequency = frequency;
        this.decayRate = 0.3;
        this.fadeArray = new Float32Array(9);
        this.fadeArray[0] = 0.954;
        this.fadeArray[1] = 0.903;
        this.fadeArray[2] = 0.845;
        this.fadeArray[3] = 0.778;
        this.fadeArray[4] = 0.699;
        this.fadeArray[5] = 0.602;
        this.fadeArray[6] = 0.477;
        this.fadeArray[7] = 0.301;
        this.fadeArray[8] = 0;
    }
    play() {
        const { audios: audios, context: context } = $e0ea8097d55977c9$export$85990f0f98a390bb;
        if (audios.has(this.frequency)) return;
        const oscillatorNode = new OscillatorNode(context, {
            frequency: this.frequency,
            type: $e0ea8097d55977c9$export$85990f0f98a390bb.currentWaveType
        });
        const gainNode = new GainNode(context);
        const dynamicsCompressorNode = new DynamicsCompressorNode(context, {
            threshold: -48,
            knee: 0
        });
        oscillatorNode.connect(gainNode).connect(dynamicsCompressorNode).connect(context.destination);
        oscillatorNode.start(context.currentTime);
        audios.set(this.frequency, {
            oscillatorNode: oscillatorNode,
            gainNode: gainNode
        });
    }
    stop() {
        const { audios: audios, context: context } = $e0ea8097d55977c9$export$85990f0f98a390bb;
        const audio = audios.get(this.frequency);
        if (!audio) return;
        const { gainNode: gainNode, oscillatorNode: oscillatorNode } = audio;
        gainNode.gain.setValueCurveAtTime(this.fadeArray, context.currentTime, this.decayRate);
        setTimeout(()=>{
            oscillatorNode.stop(context.currentTime);
        }, this.decayRate * 1000 + 100);
        audios.delete(this.frequency);
    }
    static setWaveType(waveType) {
        $e0ea8097d55977c9$export$85990f0f98a390bb.currentWaveType = waveType;
    }
    static getWaveType() {
        return $e0ea8097d55977c9$export$85990f0f98a390bb.currentWaveType;
    }
}



const $d96e081495c25534$export$df61b30b684217c0 = (eventBus, keyRegistry, config)=>{
    const sound = new (0, $e0ea8097d55977c9$export$85990f0f98a390bb)(config.frequency);
    const classes = config.name.includes('#') ? 'key sharp' : 'key';
    const playNote = ()=>{
        keyElement.element?.classList.add('pressed');
        sound.play();
    };
    const stopNote = ()=>{
        keyElement.element?.classList.remove('pressed');
        sound.stop();
    };
    const onPlay = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        playNote();
        eventBus.emit((0, $2f574e067eb2596f$export$ada873a34909da65).NOTE_PRESSED, {
            note: config.name,
            frequency: config.frequency
        });
    };
    const onStop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        stopNote();
        eventBus.emit((0, $2f574e067eb2596f$export$ada873a34909da65).NOTE_RELEASED, {
            note: config.name,
            frequency: config.frequency
        });
    };
    const keyElement = (0, $5be042668c706f09$export$159d9494db57879b)([
        (0, $5be042668c706f09$export$afc1bfabebaf28a2)(config.hint).class('hint')
    ]).class(classes).attribute('data-note', config.name).listen('mousedown', onPlay).listen('touchstart', onPlay).listen('mouseup', onStop).listen('mouseleave', onStop).listen('touchend', onStop);
    document.addEventListener('keydown', (event)=>{
        if (event.key.toLowerCase() === config.hint.toLowerCase()) onPlay(event);
    });
    document.addEventListener('keyup', (event)=>{
        if (event.key.toLowerCase() === config.hint.toLowerCase()) onStop(event);
    });
    const keyElementWithMethods = keyElement;
    keyElementWithMethods.playNote = playNote;
    keyElementWithMethods.stopNote = stopNote;
    keyElementWithMethods.config = config;
    keyRegistry.register(keyElementWithMethods);
    return keyElementWithMethods;
};



const $a6cabd9c6c20a373$export$cfdd767f5a513509 = (eventBus, keyRegistry, config)=>{
    const classes = (0, $041a823542846931$export$a1d0d20ee9546562)() ? 'keyboard' : 'keyboard show-hint';
    const keys = config.map((keyConfig)=>(0, $d96e081495c25534$export$df61b30b684217c0)(eventBus, keyRegistry, keyConfig));
    return (0, $5be042668c706f09$export$159d9494db57879b)(keys).class(classes);
};




const $c1b90fb551eb5254$export$9ad89fcc05303611 = (eventBus)=>{
    const loopButton = (0, $5be042668c706f09$export$2ba01fb71ed41cb6)('Start Loop').class('loop-btn');
    let currentState = {
        isRecording: false,
        isPlaying: false,
        hasLoop: false
    };
    const updateUI = (state)=>{
        currentState = state;
        if (state.isRecording) {
            loopButton.element.textContent = 'Stop Recording';
            loopButton.element.className = 'loop-btn stop-btn';
        } else if (state.isPlaying) {
            loopButton.element.textContent = 'Clear Loop';
            loopButton.element.className = 'loop-btn clear-btn';
        } else if (state.hasLoop) {
            loopButton.element.textContent = 'Start Loop';
            loopButton.element.className = 'loop-btn start-btn';
        } else {
            loopButton.element.textContent = 'Start Loop';
            loopButton.element.className = 'loop-btn start-btn';
        }
    };
    const handleLoopAction = ()=>{
        if (currentState.isRecording) eventBus.emit((0, $2f574e067eb2596f$export$ada873a34909da65).LOOP_STOP);
        else if (currentState.isPlaying) eventBus.emit((0, $2f574e067eb2596f$export$ada873a34909da65).LOOP_CLEAR);
        else eventBus.emit((0, $2f574e067eb2596f$export$ada873a34909da65).LOOP_START);
    };
    loopButton.listen('click', handleLoopAction);
    document.addEventListener('keydown', (event)=>{
        if (event.code === 'Space') {
            event.preventDefault();
            handleLoopAction();
        }
    });
    eventBus.on((0, $2f574e067eb2596f$export$ada873a34909da65).STATE_CHANGED, (state)=>{
        if (state) updateUI(state);
    });
    return (0, $5be042668c706f09$export$159d9494db57879b)([
        (0, $5be042668c706f09$export$159d9494db57879b)([
            loopButton
        ]).class('record-section')
    ]).class('recording-controls');
};





const $35ce0a66f9b34aff$export$ada873a34909da65 = {
    WAVE_TYPE_CHANGED: 'wave:type:changed'
};
const $35ce0a66f9b34aff$export$3af7f25b217a4e9f = (eventBus)=>{
    const handleWaveChange = (event)=>{
        const target = event.target;
        const waveType = target.value;
        (0, $e0ea8097d55977c9$export$85990f0f98a390bb).setWaveType(waveType);
        eventBus.emit($35ce0a66f9b34aff$export$ada873a34909da65.WAVE_TYPE_CHANGED, {
            waveType: waveType
        });
    };
    const currentWaveType = (0, $e0ea8097d55977c9$export$85990f0f98a390bb).getWaveType();
    const options = (0, $09eabb53e0d46f41$export$cafdd0d42ceca25c).map((waveOption)=>{
        const opt = (0, $5be042668c706f09$export$a75d1723e6bda2ec)(waveOption.label).attribute('value', waveOption.value);
        if (waveOption.value === currentWaveType) opt.attribute('selected', 'selected');
        return opt;
    });
    const selectElement = (0, $5be042668c706f09$export$2e6c959c16ff56b8)(options).class('wave-selector').listen('change', handleWaveChange);
    return (0, $5be042668c706f09$export$159d9494db57879b)([
        selectElement
    ]).class('wave-selector-container');
};


class $770131c225760fef$var$DIContainer {
    instance(name, instance) {
        this.register(name, {
            factory: instance,
            singleton: true
        });
    }
    factory(name, factory, dependencies = [], singleton = true) {
        this.register(name, {
            factory: factory,
            dependencies: dependencies,
            singleton: singleton
        });
    }
    register(name, descriptor) {
        if (this.services.has(name)) throw new Error(`Service ${name} is already registered`);
        if (!descriptor.factory) throw new Error(`Service ${name} must have a factory or instance`);
        const definition = {
            factory: descriptor.factory,
            dependencies: descriptor.dependencies ?? [],
            singleton: descriptor.singleton ?? true
        };
        this.services.set(name, definition);
    }
    resolve(name) {
        const service = this.services.get(name);
        if (!service) throw new Error(`Service ${name} is not registered`);
        if (service.singleton && service.instance !== undefined) return service.instance;
        let instance;
        if (typeof service.factory === 'function') {
            const resolvedDependencies = service.dependencies.map((dep)=>this.resolve(dep));
            const factory = service.factory;
            instance = factory(...resolvedDependencies);
        } else instance = service.factory;
        if (service.singleton) service.instance = instance;
        return instance;
    }
    createFactory(name) {
        return (...args)=>{
            const resolvedService = this.resolve(name);
            return resolvedService(...args);
        };
    }
    has(name) {
        return this.services.has(name);
    }
    getServiceNames() {
        return Array.from(this.services.keys());
    }
    clear() {
        this.services.clear();
    }
    service(name) {
        return new $770131c225760fef$var$ServiceBuilder(name, this);
    }
    constructor(){
        this.services = new Map();
    }
}
class $770131c225760fef$var$ServiceBuilder {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.descriptor = {};
    }
    factory(factoryFn) {
        this.descriptor.factory = factoryFn;
        return this;
    }
    instance(instance) {
        this.descriptor.factory = instance;
        this.descriptor.singleton = true;
        return this;
    }
    depends(...dependencies) {
        this.descriptor.dependencies = dependencies;
        return this;
    }
    singleton(isSingleton = true) {
        this.descriptor.singleton = isSingleton;
        return this;
    }
    transient() {
        return this.singleton(false);
    }
    register() {
        this.container.register(this.name, this.descriptor);
    }
}
const $770131c225760fef$export$479d1ccc5f2ab701 = new $770131c225760fef$var$DIContainer();
function $770131c225760fef$var$singletonService(name, factory, ...dependencies) {
    return $770131c225760fef$export$479d1ccc5f2ab701.register(name, {
        factory: factory,
        dependencies: dependencies,
        singleton: true
    });
}
function $770131c225760fef$var$transientService(name, factory, ...dependencies) {
    return $770131c225760fef$export$479d1ccc5f2ab701.register(name, {
        factory: factory,
        dependencies: dependencies,
        singleton: false
    });
}
const $770131c225760fef$var$serviceConfig = [
    {
        name: 'eventBus',
        instance: new (0, $d5ab0e61de8d05a3$export$4fae95256245c8c0)()
    },
    {
        name: 'recordingService',
        factory: (eventBus)=>new (0, $2f574e067eb2596f$export$9990ea4e6d0d6bd5)(eventBus),
        dependencies: [
            'eventBus'
        ]
    },
    {
        name: 'keyRegistry',
        factory: (eventBus)=>new (0, $566e2212a25b5c97$export$a100a513ac3d7fb0)(eventBus),
        dependencies: [
            'eventBus'
        ]
    },
    {
        name: 'keyboardFactory',
        factory: (eventBus, keyRegistry)=>(config)=>(0, $a6cabd9c6c20a373$export$cfdd767f5a513509)(eventBus, keyRegistry, config),
        dependencies: [
            'eventBus',
            'keyRegistry'
        ],
        singleton: false
    },
    {
        name: 'recordingControlsFactory',
        factory: (eventBus)=>()=>(0, $c1b90fb551eb5254$export$9ad89fcc05303611)(eventBus),
        dependencies: [
            'eventBus'
        ],
        singleton: false
    },
    {
        name: 'waveSelectorFactory',
        factory: (eventBus)=>()=>(0, $35ce0a66f9b34aff$export$3af7f25b217a4e9f)(eventBus),
        dependencies: [
            'eventBus'
        ],
        singleton: false
    }
];
$770131c225760fef$var$serviceConfig.forEach((config)=>{
    if ('instance' in config) $770131c225760fef$export$479d1ccc5f2ab701.instance(config.name, config.instance);
    else {
        const factory = config.factory;
        const singleton = 'singleton' in config ? config.singleton : true;
        if (singleton) $770131c225760fef$var$singletonService(config.name, factory, ...config.dependencies);
        else $770131c225760fef$var$transientService(config.name, factory, ...config.dependencies);
    }
});


const $b4e14b6b8da86996$var$controlsContainer = document.querySelector('.controls-container');
const $b4e14b6b8da86996$var$keyboardContainer = document.querySelector('.keyboard');
if (!$b4e14b6b8da86996$var$keyboardContainer || !$b4e14b6b8da86996$var$controlsContainer) throw new Error('Required containers were not found');
const $b4e14b6b8da86996$var$config = [
    {
        name: 'C4',
        frequency: 261.63,
        hint: 'a'
    },
    {
        name: 'C#4',
        frequency: 277.18,
        hint: 'w'
    },
    {
        name: 'D4',
        frequency: 293.66,
        hint: 's'
    },
    {
        name: 'D#4',
        frequency: 311.13,
        hint: 'e'
    },
    {
        name: 'E4',
        frequency: 329.63,
        hint: 'd'
    },
    {
        name: 'F4',
        frequency: 349.23,
        hint: 'f'
    },
    {
        name: 'F#4',
        frequency: 369.99,
        hint: 't'
    },
    {
        name: 'G4',
        frequency: 392,
        hint: 'g'
    },
    {
        name: 'G#4',
        frequency: 415.3,
        hint: 'y'
    },
    {
        name: 'A4',
        frequency: 440,
        hint: 'h'
    },
    {
        name: 'A#4',
        frequency: 466.16,
        hint: 'u'
    },
    {
        name: 'B4',
        frequency: 493.88,
        hint: 'j'
    },
    {
        name: 'C5',
        frequency: 523.25,
        hint: 'k'
    },
    {
        name: 'C#5',
        frequency: 554.37,
        hint: 'o'
    },
    {
        name: 'D5',
        frequency: 587.33,
        hint: 'l'
    },
    {
        name: 'D#5',
        frequency: 622.25,
        hint: 'p'
    },
    {
        name: 'E5',
        frequency: 659.26,
        hint: ';'
    },
    {
        name: 'F5',
        frequency: 698.46,
        hint: "'"
    },
    {
        name: 'F#5',
        frequency: 739.99,
        hint: ']'
    },
    {
        name: 'G5',
        frequency: 783.99,
        hint: '\\'
    }
];
(0, $770131c225760fef$export$479d1ccc5f2ab701).resolve('recordingService');
const $b4e14b6b8da86996$var$keyboardFactory = (0, $770131c225760fef$export$479d1ccc5f2ab701).resolve('keyboardFactory');
const $b4e14b6b8da86996$var$recordingControlsFactory = (0, $770131c225760fef$export$479d1ccc5f2ab701).resolve('recordingControlsFactory');
const $b4e14b6b8da86996$var$waveSelectorFactory = (0, $770131c225760fef$export$479d1ccc5f2ab701).resolve('waveSelectorFactory');
const $b4e14b6b8da86996$var$controlsElement = $b4e14b6b8da86996$var$recordingControlsFactory();
const $b4e14b6b8da86996$var$waveSelectorElement = $b4e14b6b8da86996$var$waveSelectorFactory();
const $b4e14b6b8da86996$var$keyboardElement = $b4e14b6b8da86996$var$keyboardFactory($b4e14b6b8da86996$var$config);
$b4e14b6b8da86996$var$controlsContainer.appendChild($b4e14b6b8da86996$var$controlsElement.render());
$b4e14b6b8da86996$var$controlsContainer.appendChild($b4e14b6b8da86996$var$waveSelectorElement.render());
$b4e14b6b8da86996$var$keyboardContainer.appendChild($b4e14b6b8da86996$var$keyboardElement.render());


//# sourceMappingURL=path0.a68dae15.js.map
